import React, { memo } from "react";
import { Link } from "react-router-dom";
import "./ItemCard.scss";
import { formatName } from "../../../services/data_requests";

const ItemCard = ({ item, type }) => {
  const image =
    item.prev_img_url ||
    item.preview_img_url ||
    item.preview ||
    item.image ||
    "";

  const link =
    type === "artwork"
      ? `/artwork/${formatName(item.name)}-${item.id}`
      : `/nft/${formatName(item.name)}-${item.id}`;

  return (
    <div className="shared-item-card">
      <Link to={link} className="shared-item-card__link">
        <div className="shared-item-card__image">
          {image ? (
            <img
              src={image}
              alt={item.name || "Artwork"}
              loading="lazy"
              decoding="async"
            />
          ) : null}
        </div>
        <div className="shared-item-card__meta">
          <div className="shared-item-card__title">{item.name}</div>
          {item.artist?.name ? (
            <div className="shared-item-card__artist">{item.artist.name}</div>
          ) : null}
        </div>
      </Link>
    </div>
  );
};

const areEqual = (prevProps, nextProps) => {
  if (prevProps.type !== nextProps.type) return false;
  if (prevProps.item.id !== nextProps.item.id) return false;
  if (prevProps.item.name !== nextProps.item.name) return false;
  const prevArtist = prevProps.item.artist?.name ?? "";
  const nextArtist = nextProps.item.artist?.name ?? "";
  return prevArtist === nextArtist;
};

export default memo(ItemCard, areEqual);
